import { MessageCircle, Phone, Mail } from "lucide-react";
import { COMPANY_DATA } from "../../constant/CompanyData";

const WHATSAPP_URL =
  "https://wa.me/919755010858?text=Hi%2C%20I%27d%20like%20a%20quote%20for%20some%20hardware";

// Replaces the old contact form, which moved to quantarock.in along with the
// rest of the company pages. Products are quoted rather than priced, so the
// shop still needs a direct route to sales on every visit.
const EnquiryCta = () => {
  const actions = [
    {
      icon: MessageCircle,
      label: "WhatsApp",
      value: "Chat with sales",
      href: WHATSAPP_URL,
      external: true,
      accent: "bg-green-600 hover:bg-green-700 text-white",
    },
    {
      icon: Phone,
      label: "Call",
      value: COMPANY_DATA.phoneNumber,
      href: `tel:${COMPANY_DATA.phoneNumber}`,
      accent:
        "bg-[var(--website-secondary-color)] hover:opacity-90 text-[var(--website-primary-color)]",
    },
    {
      icon: Mail,
      label: "Email",
      value: COMPANY_DATA.mailID,
      href: COMPANY_DATA.mailURL,
      accent: "bg-white hover:bg-gray-100 text-[var(--website-primary-color)]",
    },
  ];

  return (
    <section
      className="py-16 px-6"
      style={{ backgroundColor: "var(--website-primary-color)" }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
          Need a quote?
        </h2>
        <p className="text-[var(--website-text-color)] text-base md:text-lg mb-10 max-w-2xl mx-auto">
          Send us the models and quantities you need. Our team replies with
          pricing, stock and lead times — usually the same working day.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {actions.map(({ icon: Icon, label, value, href, external, accent }) => (
            <a
              key={label}
              href={href}
              {...(external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
              className={`flex flex-col items-center gap-2 px-5 py-6 rounded-xl font-semibold transition-all duration-300 hover:scale-[1.03] ${accent}`}
            >
              <Icon size={26} />
              <span className="text-base">{label}</span>
              <span className="text-sm font-normal opacity-80 break-all">
                {value}
              </span>
            </a>
          ))}
        </div>

        <p className="text-[var(--website-text-color)] text-sm mt-10">
          {COMPANY_DATA.address}
        </p>
      </div>
    </section>
  );
};

export default EnquiryCta;
